const { getData, postData, putData } = require("../apiClient");


export const GetAllRoomList = async () => {
    try {
        const result = await getData(`/assign-room-offer/get-room`);
        return {
            data: {
                success: true,
                ...result
            }
        };
    } catch (error) {
        console.error("Get All Room List API Error:", error);
        return {
            data: {
                success: false,
                error: error?.status === 400 ? error.error : error?.message,
                status: error?.status,
            },
        };
    }
}

export const CreateAssignRoomOffer = async (data) => {
    try {
        const result = await postData(`/assign-room-offer/assign-room-offer`, data);
        return {
            data: {
                success: true,
                ...result
            }
        };
    } catch (error) {
        console.error("Create Assign Room Offer API Error:", error);
        return {
            data: {
                success: false,
                error: error?.status === 400 ? error.error : error?.message,
                status: error?.status,
            },
        };
    }
}

export const getAllRoomOffer = async ({ month_year }) => {
    try {
        const result = await postData(`/assign-room-offer/get-room-offer/${month_year}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error("Get All Room Offer List API Error:", error);
        return {
            data: {
                success: false,
                error: error?.status === 400 ? error.error : error?.message,
                status: error?.status,
            },
        };
    }
}

export const getRoomOfferById = async (id) => {
    try {
        const result = await getData(`/assign-room-offer/get-room-offer/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Room Offer data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
                status: error.status,
            },
        };
    }
}

export const UpdateRoomOffer = async ({ id, data }) => {
    try {
        const result = await putData(`/assign-room-offer/update-room-offer/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Copy Assign Room Offer API Error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
}